export async function getAttendance() {
  try {
    const response = await fetch('https://api.juangutierreza.com/rj/attendance', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      cache: 'default',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
      return { code: response.status, message: 'Error getting attendance' };
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error:', error);
    return { code: 500, message: 'Error getting attendance' };
  }
}

export async function deleteAttendance(id) {
  try {
    const response = await fetch(`https://api.juangutierreza.com/rj/attendance/delete?id=${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      cache: 'default',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error:', error);
    return { code: 500, message: 'Error deleting attendance' };
  }
}
